<template>
    <!-- 左侧 导航菜单 -->
    <nav class="left-menu bg-white box-shadow">
        <ul class="posi-relative bg-white transition-2">
            <li v-if="userInfo.userType=='2'" :class="{active:menuSlt==1}" @click="$router.push({path:'/myaccount'})">
                <img v-if="menuSlt!=1" src="../../assets/img/menu-icon/wdzc_h.png"/>
                <img v-if="menuSlt==1" src="../../assets/img/menu-icon/wdzc_l.png"/>
                <span>我的资产</span>
            </li>
            <li class="fundBuy" :class="{active:menuSlt==2}" @click="$router.push({path:'/fundslist'}),$tools.setSession('login_one', 'two')">
                <img v-if="menuSlt!=2" src="../../assets/img/menu-icon/jjgm_h.png"/>
                <img v-if="menuSlt==2" src="../../assets/img/menu-icon/jjgm_l.png"/>
                <span>基金购买</span>
            </li>
            <li v-if="userInfo.userType=='2'" :class="{active:menuSlt==3}" class="zhanghuchaxun" 
                @click="$router.push({path:'/accountQuery'}),$tools.setSession('login_one', 'two')">
                <img v-if="menuSlt!=3" src="../../assets/img/menu-icon/zhcx_h.png"/>
                <img v-if="menuSlt==3" src="../../assets/img/menu-icon/zhcx_l.png"/>
                <span>交易记录</span>
            </li>
            <li :class="{active:menuSlt==4}" class="wodezixuan" @click="$router.push({path:'/myselection'}),$tools.setSession('login_one', 'two')">
                <img v-if="menuSlt!=4" src="../../assets/img/menu-icon/wdzx_h.png"/>
                <img v-if="menuSlt==4" src="../../assets/img/menu-icon/wdzx_l.png"/>
                <span>我的自选</span>
            </li>
             <li v-if="userInfo.userType=='2'" :class="{active:menuSlt==5}" class="wodezixuan" @click="$router.push({path:'/redeemBuyList'}),$tools.setSession('login_one', 'two')">
                <img v-if="menuSlt!=5" src="../../assets/img/menu-icon/redeemBuy_g.png"/>
                <img v-if="menuSlt==5" src="../../assets/img/menu-icon/redeemBuy_r.png"/>
                <span>赎回转认购</span>
            </li>
            <!-- 申购入口 -->
            <li v-if="userInfo.userType=='2'" :class="{active:menuSlt==15}" class="wodezixuan" @click="$router.push({path:'/subscribeBuyList'}),$tools.setSession('login_one', 'two')">
                <img v-if="menuSlt!=15" src="../../assets/img/menu-icon/purchasefalse.png"/>
                <img v-if="menuSlt==15" src="../../assets/img/menu-icon/purchasetrue.png"/>
                <span>赎回转申购</span>
            </li>
            <li class="fundFixed" v-if="userInfo.userType=='2'" :class="{active:menuSlt==6}" @click="$router.push({path:'/fundsFixed'}),$tools.setSession('login_one', 'two')">
                <img v-if="menuSlt!=6" src="../../assets/img/menu-icon/wddt_h.png"/>
                <img v-if="menuSlt==6" src="../../assets/img/menu-icon/wddt_l.png"/>
                <span>我的定投计划</span>
            </li>				
            <li v-if="userInfo.userType=='2'" :class="{active:menuSlt==7}" @click="$router.push({path:'/myappointment'}),$tools.setSession('login_one', 'two')">
                <img v-if="menuSlt!=7" src="../../assets/img/menu-icon/wdyyjh_h.png"/>
                <img v-if="menuSlt==7" src="../../assets/img/menu-icon/wdyyjh_l.png"/>
                <span>我的预约计划</span>
            </li>
            <li class="bankInfo" v-if="userInfo.userType=='2'" :class="{active:menuSlt==8}" @click="$router.push({path:'/bankCards'}),$tools.setSession('login_one', 'two')">
                <img v-if="menuSlt!=8" src="../../assets/img/menu-icon/yhkgl_h.png"/>
                <img v-if="menuSlt==8" src="../../assets/img/menu-icon/yhkgl_l.png"/>
                <span>银行卡管理</span>
            </li>
            <li class="jifen" :class="{active:menuSlt==9}" @click="$router.push({path:'/myintegral'}),$tools.setSession('login_one', 'two')">
                <img v-if="menuSlt!=9" src="../../assets/img/menu-icon/wdjf_h.png"/>
                <img v-if="menuSlt==9" src="../../assets/img/menu-icon/wdjf_l.png"/>
                <span>我的积分</span>
            </li>
            <!-- <li :class="{active:menuSlt==12}" @click="$router.push({path:'/welfare'}),$tools.setSession('login_one', 'two')">
                <img v-if="menuSlt!=12" src="../../assets/img/menu-icon/fldh_h.png"/>
                <img v-if="menuSlt==12" src="../../assets/img/menu-icon/fldh_l.png"/>
                <span>福利兑换</span>
            </li> -->
            <li class="account" :class="{active:menuSlt==10}" @click="$router.push({path:'/accountmanagement'})">
                <img v-if="menuSlt!=10" src="../../assets/img/menu-icon/zhxx_h.png"/>
                <img v-if="menuSlt==10" src="../../assets/img/menu-icon/zhxx_l.png"/>
                <span>账号管理</span>
            </li>
            <li v-if="userInfo.userType=='2'" :class="{active:menuSlt==11}" @click="$router.push({path:'/mymessage'}),$tools.setSession('login_one', 'two')">
                <img v-if="menuSlt!=11" src="../../assets/img/menu-icon/wdxx_h.png" style="margin-top:.1rem"/>
                <img v-if="menuSlt==11" src="../../assets/img/menu-icon/wdxx_l.png" style="margin-top:.1rem"/>
                <span>我的消息</span>
            </li>
            <li :class="{active:menuSlt==12}" @click="$router.push({path:'/treatyList'})">
                <img v-if="menuSlt!=12" src="../../assets/img/menu-icon/xy_wxz.png" style="margin-top:.1rem"/>
                <img v-if="menuSlt==12" src="../../assets/img/menu-icon/xy_yxz.png" style="margin-top:.1rem"/>
                <span>协议列表</span>
            </li>
        </ul>
    </nav>
</template>
<script>
    export default {
        mounted(){
            
        },
        props:['menuSlt'],
        data(){
            return{
                // userInfo:this.$store.state.userInfo //-- 用户信息
            }
        },
        computed:{
            userInfo(){
                return this.$store.state.userInfo;
            }
        }
    }
</script>
<style lang="less" scoped>
    /*左侧菜单*/
    .left-menu{ 
        width: 9.5rem; 
        height:34.1; //37.1rem; 
        li{ 
            padding:1rem; display: flex;
            border-left:.1rem solid transparent;
            font-size: .8rem; font-family:MicrosoftYaHei; font-weight: 400;
            cursor: pointer; transition: all .2s;
            /*图标*/
            img{width: .9rem; height: .9rem;/*margin-top:.05rem;*/}
            /*文字*/
            >span:last-child{ padding-left:.6rem; }
        }
        li+li{border-top:.05rem solid #E5E5E5;}
        li:last-child{border-bottom:.05rem solid #E5E5E5;}
        li.fundBuy img, li.bankInfo img { width: 1rem; height: .7rem; margin-top:.175rem; }
        /*账户查询*/
        li.zhanghuchaxun { 
            img{ 
                margin-top: .1rem;
            } 
        }
        /*我的自选*/
        li.wodezixuan { 
            img{ 
                margin-top: .05rem;
            } 
        }
        /*我的定投计划*/
        li.fundFixed {
            img{ 
                width: .8rem; 
                height: .9rem; 
                margin-top:.1rem; 
            }
        }
        li.jifen {
            img{
                width:.9rem;
                height:.9rem;
                margin-top: .1rem;
            }
        }
        // 账号管理
        li.account{
            img{
                width:1rem;
                height:.7rem;
                margin-top:.2rem;
            }
        }   
        li.active,li:hover{ 
            color:#C12B1C; border-left:.1rem solid #E72A18; background: #F9F9F9;
        }
    }
</style>


// WEBPACK FOOTER //
// src/components/publicCpts/leftMenu.vue